import React, { useRef } from 'react';
import AboutSection from './aboutSection';
import Contact from './contact';
import Language from './language';
import Expertise from './expertise';
import { ResumeProfile } from './resume_output';
import { MainDetails } from './resume_output';
import { Experience } from './resume_output';
import { Education } from './resume_output';
import { useStores } from '../../store/index';
import { useObserver } from 'mobx-react';
import { WebsiteLinks } from './resume_output';
import { Hobbies } from './resume_output';
import { Internships } from './resume_output';
import { References } from './resume_output';
import { Courses } from './resume_output';
import { ExtraActivities } from './resume_output';
import { useReactToPrint } from 'react-to-print';
import './resume.css';


function ResumeOutput1({ handleShowResume }) {
    const resumeRef = useRef(null);

    const { ResumeStore } = useStores();
    const handleDownload = useReactToPrint({
        content: () => resumeRef.current,
    });

    const closeResume = () => {
        if (handleShowResume) {
            handleShowResume();
        }
    }



    return useObserver(() => (


        <div className='flex flex-col items-center md:w-full lg:w-full w-full justify-center mb-5'>
            {/* <button className=' flex items-center justify-center ml-auto bg-primary text-gray-500 px-4 py-2 rounded-lg my-3 mr-2'>
                <TbTemplate />
                Select Template
            </button> */}
            <div className='flex justify-end ml-auto'>
                <button className=' md:flex lg:flex hidden  items-center justify-end px-4 py-2 bg-primary mr-2 text-white rounded-full my-3 border-none ' onClick={closeResume} >
                    Close
                </button>

            </div>
            <div ref={resumeRef} className='gil-reg flex relative md:w-[60%] lg:w-[60%] w-full mx-auto mt-2 mb-2 shadow-2xl'>

                {/* <div className='w-full flex absolute bg-primary md:h-[150px] lg:h-[150px] h-[120px] md:top-[90px] lg:top-[90px] top-[50px]'>
                    <img src={ResumeStore.resumeBuilder?.profile ?? "https://images.unsplash.com/photo-1508341591423-4347099e1f19?q=80&w=1000&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8Nnx8bWVufGVufDB8fDB8fHww"} alt=" no image" className=' md:w-[220px] md:h-[220px] lg:w-[220px] lg:h-[220px] w-[150px] h-[150px]  rounded-full  md:ml-[10%] lg:[ml-10%] ml-[8%] -mt-[4%]  border-4 object-cover border-resume_primary' />
                    <div className='flex flex-col bg-primary'>
                        <p className='namemobile'>{ResumeStore.resumeBuilder.personalDetails?.firstName ?? "RICHARD"}</p>
                        <p className='text-black md:text-2xl lg:text-2xl text-xl md:pl-10 md:pr-2 md:py-2 md:ml-3 lg:pl-10 lg:pr-2 lg:py-2 lg:ml-3 pl-10 py-2'>{ResumeStore.resumeBuilder.personalDetails?.lastName ?? "Sandez"}</p>
                        <p className='text-white md:ml-36 lg:ml-36 ml-10 text-center md:text-2xl lg:text-2xl text-xl md:bottom-0'>{ResumeStore.resumeBuilder.personalDetails?.jobTitle ?? "Product Designer"}</p>
                    </div>
                    <p className='absolute px-3 py-3 text-white right-1'>{ResumeStore.resumeBuilder.personalDetails.dateOfBirth}</p>

                </div> */}
                <div className='ml-0 md:ml-[5%] lg:ml-[5%] bg-black h-full w-[40%] pl-2'>
                    <ResumeProfile />
                    <AboutSection />
                    <Contact />
                    <Expertise />
                    <Courses />
                    <WebsiteLinks />
                    <Language />
                    <References />
                    <Hobbies />
                </div>

                <div className='h-full w-[60%] pl-2 md:pl-5'>
                    <MainDetails />
                    <Experience />
                    <Education />

                    <Internships />
                    {/* <Summary /> */}
                    <ExtraActivities />
                </div>

            </div>
            <div className='flex gap-5'>
                <button className=' md:hidden lg:hidden flex  items-center justify-end px-4 py-2 bg-primary text-white rounded-lg my-3 border-none ' onClick={handleDownload} >
                    Download PDF
                </button>

                <button onClick={closeResume} className='md:hidden lg:hidden flex items-center px-4 py-2 bg-primary text-white rounded-lg my-3 border-none '  >
                    Close
                </button>
            </div>
        </div>
    ));

}




export default ResumeOutput1;
